<template>
    <div class="blueBg">
        <div class="inner">
            <h3>{{ $t('menu.policy') }}</h3>

            <div class="textBox">
                <!-- block -->
                <p class="mt-0" v-html="$t('policy.block1')"></p>
                <p class="mt-0" v-html="$t('policy.block2')"></p>
                <!-- privacy -->
                <p class="mt-4 font-weight-bold" v-html="$t('policy.privacy.title')"></p>
                <p class="mt-0" v-html="$t('policy.privacy.text1')"></p>
                <p class="mt-0" v-html="$t('policy.privacy.text2')"></p>
                <p class="mt-0" v-html="$t('policy.privacy.text3')"></p>

                <!-- article - 1 -->
                <p class="mt-4 font-weight-bold" v-html="$t('policy.article1.title')"></p>
                <p v-html="$t('policy.article1.text1')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article1.point1')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article1.point2')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article1.point3')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article1.point4')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article1.point5')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article1.point6')"></p>
                <p class="p-0" v-html="$t('policy.article1.text2')"></p>

                <!-- article - 2 -->
                <p class="mt-4 font-weight-bold" v-html="$t('policy.article2.title')"></p>
                <p v-html="$t('policy.article2.text1')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article2.point1')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article2.point2')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article2.point3')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article2.point4')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article2.point5')"></p>
                <p v-html="$t('policy.article2.text2')"></p>
                <p v-html="$t('policy.article2.text3')"></p>
                <p v-html="$t('policy.article2.text4')"></p>

                <!-- article - 3 -->
                <p class="mt-4 font-weight-bold" v-html="$t('policy.article3.title')"></p>
                <p v-html="$t('policy.article3.text1')"></p>
                <p v-html="$t('policy.article3.text2')"></p>
                <p v-html="$t('policy.article3.text3')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article3.point1')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article3.point2')"></p>
                <p v-html="$t('policy.article3.text4')"></p>

                <!-- article - 4 -->
                <p class="mt-4 font-weight-bold" v-html="$t('policy.article4.title')"></p>
                <p v-html="$t('policy.article4.text1')"></p>

                <!-- article - 5 -->
                <p class="mt-4 font-weight-bold" v-html="$t('policy.article5.title')"></p>
                <p v-html="$t('policy.article5.text1')"></p>
                <p v-html="$t('policy.article5.text2')"></p>

                <!-- article - 6 -->
                <p class="mt-4 font-weight-bold" v-html="$t('policy.article6.title')"></p>
                <p v-html="$t('policy.article6.text1')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article6.point1')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article6.point2')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article6.point3')"></p>

                <!-- article - 7 -->
                <p class="mt-4 font-weight-bold" v-html="$t('policy.article7.title')"></p>
                <p v-html="$t('policy.article7.text1')"></p>
                <p class="mt-4 font-weight-bold" v-html="$t('policy.article7.sub1.title')"></p>
                <p v-html="$t('policy.article7.sub1.text1')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article7.sub1.point1')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article7.sub1.point2')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article7.sub1.point3')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article7.sub1.point4')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article7.sub1.point5')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article7.sub1.point6')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article7.sub1.point7')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article7.sub1.point8')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article7.sub1.point9')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article7.sub1.point10')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article7.sub1.point11')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article7.sub1.point12')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article7.sub1.point13')"></p>
                <p class="mt-4 font-weight-bold" v-html="$t('policy.article7.sub2.title')"></p>
                <p v-html="$t('policy.article7.sub2.text1')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article7.sub2.point1')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article7.sub2.point2')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article7.sub2.point3')"></p>

                <!-- article - 8 -->
                <p class="mt-4 font-weight-bold" v-html="$t('policy.article8.title')"></p>
                <p v-html="$t('policy.article8.text1')"></p>

                <!-- article - 9 -->
                <p class="mt-4 font-weight-bold" v-html="$t('policy.article9.title')"></p>
                <p v-html="$t('policy.article9.text1')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article9.point1')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article9.point2')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article9.point3')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article9.point4')"></p>
                <p class="p-0 pl-4 padding" v-html="$t('policy.article9.point4_1')"></p>
                <p class="p-0 pl-4 padding" v-html="$t('policy.article9.point4_2')"></p>
                <p class="p-0 pl-4 padding" v-html="$t('policy.article9.point4_3')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article9.point5')"></p>

                <!-- article - 10 -->
                <p class="mt-4 font-weight-bold" v-html="$t('policy.article10.title')"></p>
                <p class="mt-4 font-weight-bold" v-html="$t('policy.article10.sub1.title')"></p>
                <p v-html="$t('policy.article10.sub1.text1')"></p>
                <p v-html="$t('policy.article10.sub1.text2')"></p>
                <p v-html="$t('policy.article10.sub1.text3')"></p>
                <p v-html="$t('policy.article10.sub1.text4')"></p>
                <p v-html="$t('policy.article10.sub1.text5')"></p>
                <p v-html="$t('policy.article10.sub1.text6')"></p>
                <p v-html="$t('policy.article10.sub1.text7')"></p>
                <p class="mt-4 font-weight-bold" v-html="$t('policy.article10.sub2.title')"></p>
                <p v-html="$t('policy.article10.sub2.text1')"></p>
                <p v-html="$t('policy.article10.sub2.text2')"></p>
                <p v-html="$t('policy.article10.sub2.text3')"></p>
                <p v-html="$t('policy.article10.sub2.text4')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article10.sub2.point1')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article10.sub2.point2')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article10.sub2.point3')"></p>
                <p v-html="$t('policy.article10.sub2.text5')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article10.sub2.point4')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article10.sub2.point5')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article10.sub2.point6')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article10.sub2.point7')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article10.sub2.point8')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article10.sub2.point9')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article10.sub2.point10')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article10.sub2.point11')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article10.sub2.point12')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article10.sub2.point13')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article10.sub2.point14')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article10.sub2.point15')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article10.sub2.point16')"></p>
                <p v-html="$t('policy.article10.sub2.text6')"></p>
                <p v-html="$t('policy.article10.sub2.text7')"></p>
                <p v-html="$t('policy.article10.sub2.text8')"></p>
                <p v-html="$t('policy.article10.sub2.text9')"></p>
                <p v-html="$t('policy.article10.sub2.text10')"></p>
                <p v-html="$t('policy.article10.sub2.text11')"></p>
                <p v-html="$t('policy.article10.sub2.text12')"></p>
                <p v-html="$t('policy.article10.sub2.text13')"></p>
                <p v-html="$t('policy.article10.sub2.text14')"></p>
                <p v-html="$t('policy.article10.sub2.text15')"></p>
                <p v-html="$t('policy.article10.sub2.text16')"></p>
                <p v-html="$t('policy.article10.sub2.text17')"></p>
                <p v-html="$t('policy.article10.sub2.text18')"></p>
                <p class="mt-4 font-weight-bold" v-html="$t('policy.article10.sub3.title')"></p>
                <p v-html="$t('policy.article10.sub3.text1')"></p>
                <p v-html="$t('policy.article10.sub3.text2')"></p>
                <p v-html="$t('policy.article10.sub3.text3')"></p>
                <p v-html="$t('policy.article10.sub3.text4')"></p>

                <!-- article - 11 -->
                <p class="mt-4 font-weight-bold" v-html="$t('policy.article11.title')"></p>
                <p v-html="$t('policy.article11.text1')"></p>
                <p v-html="$t('policy.article11.text2')"></p>

                <!-- article - 12 -->
                <p class="mt-4 font-weight-bold" v-html="$t('policy.article12.title')"></p>
                <p v-html="$t('policy.article12.text1')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article12.point1')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article12.point2')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article12.point3')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article12.point4')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article12.point5')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article12.point6')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article12.point7')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article12.point8')"></p>
                <p v-html="$t('policy.article12.text2')"></p>
                <p v-html="$t('policy.article12.text3')"></p>
                <p v-html="$t('policy.article12.text4')"></p>
                <p v-html="$t('policy.article12.text5')"></p>

                <!-- article - 13 -->
                <p class="mt-4 font-weight-bold" v-html="$t('policy.article13.title')"></p>
                <p v-html="$t('policy.article13.text1')"></p>
                <p v-html="$t('policy.article13.text2')"></p>
                <p v-html="$t('policy.article13.text3')"></p>
                <p v-html="$t('policy.article13.text4')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article13.point1')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article13.point2')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article13.point3')"></p>
                <p class="p-0 pl-4 num" v-html="$t('policy.article13.point4')"></p>
                <p v-html="$t('policy.article13.text5')"></p>

                <!-- article - 14 -->
                <p class="mt-4 font-weight-bold" v-html="$t('policy.article14.title')"></p>
                <p v-html="$t('policy.article14.text1')"></p>
                <p v-html="$t('policy.article14.text2')"></p>

                <!-- article - 15 -->
                <p class="mt-4 font-weight-bold" v-html="$t('policy.article15.title')"></p>
                <p v-html="$t('policy.article15.text1')"></p>
                <p v-html="$t('policy.article15.text2')"></p>

                <!-- article - 16 -->
                <p class="mt-4 font-weight-bold" v-html="$t('policy.article16.title')"></p>
                <p v-html="$t('policy.article16.text1')"></p>

                <p class="mt-5">
                    <!-- enactment date -->
                    {{ $t('outline.enactment_date', {
                        y: 2020,
                        m: 9,
                        M: 'September',
                        d: 1,
                    }) }}
                    <br>
                    <!-- revision date -->
                    {{ $t('outline.revision_date', {
                        y: 2025,
                        m: 10,
                        M: 'October',
                        d: 1,
                    }) }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'policy',

        components: {
        },

        mounted() {
        }
    }
</script>

<style>
    @media only screen and (max-width: 991px) {
        .pl-4, .px-4 {
            padding-left: 1rem !important;
        }
    }
    .underline {
        text-decoration: underline;
    }
</style>
